import { Stack } from "@mui/material";
import type { FC } from "react";
import { AssociatedFilesView } from "../../../components/associatedFiles/AssociatedFilesView";
import { AssociatedFilesDialog } from "./AssociatedFilesDialog";

export interface SelectedFile {
  readonly name: string;
  readonly url: string;
  readonly visibility: "PRIVATE" | "PUBLIC";
}

interface Props {
  readonly values: SelectedFile[];
  readonly onAdd: (value: FormData) => Promise<void>;
  readonly onDelete: (idx: number) => Promise<void>;
}

export const AssociatedFilesEdit: FC<Props> = ({ values, onAdd, onDelete }) => (
  <Stack direction="row" sx={{ alignItems: "center" }}>
    <AssociatedFilesDialog onAdd={onAdd} />
    <AssociatedFilesView values={values} groupByVisibility onRemove={onDelete} />
  </Stack>
);
